'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./login/login'));
    // Initialize multi-step registration form logic
    processInclude(require('./register/register'));
});

